import { SaveAlt } from "@material-ui/icons";
import React , { useRef } from "react";
import styles from "./style.module.css";

export const ResumeButton = ({ apiSubmit , value, setValue }) => {

  
  const refInput = useRef();

  const handleClick = (e) => {
    e.preventDefault();
    refInput.current.click();
  };

  const openFile = (file) => {
    const input = file.target;
    const inputValue = file.target.value;

    if (!inputValue) {
      return;
    }
    const reader = new FileReader();

    reader.onload = function () {
      const dataURL = reader.result;

      let image = input.files[0].type;
      let data = {
        file: dataURL,
        file_type: image.split("/")[1],
        file_name: input.files[0].name,
        file_size: input.files[0].size,
      };

      setValue(data);
    };

    reader.readAsDataURL(input.files[0]);
  };

  
  const handelSubmit = () => {
      apiSubmit(value)
  }

  return (
    <>
      <div
        className="d-flex justify-content-center justify-content-lg-between align-items-center  flex-column flex-lg-row text-center
                "
      >
        <div className="d-flex" style={{flexWrap:'wrap' , justifyContent:'center' , alignItems:'center'}}>
          <div className="ml-2">
            <div
              className={styles.btnResume}
              style={{ textAlign: "left" }}
              onClick={handleClick}
            >
              <a
                href="/#"
                style={{
                  width: "160px",
                  display: "inline-block",
                  backgroundColor: "white",
                  color: "black !important",
                }}
                className="text-center"
              >
                <SaveAlt /> آپلود رزومه{" "}
              </a>
            </div>

            <input
              type="file"
              style={{ display: "none" }}
              ref={refInput}
              onChange={openFile}
            />
          </div>
          <div>
            <div className={styles.btnNameFile} style={{ textAlign: "left" }}>
              <a
                href="/#"
                style={{
                  minWidth: "160px",
                  display: "inline-block",
                  color: "black !important",
                }}
                className="text-center"
                onClick={(e) => e.preventDefault()}
              >
                {value.file_name ? value.file_name : "نام فایل"}
              </a>
            </div>
          </div>
        </div>
        <div className={styles.btnWhy} style={{ textAlign: "left" }}>
          <div
            onClick={() => handelSubmit()}
            style={{
              width: "200px",
              display: "inline-block",
            }}
            className="text-center"
          >
            {" "}
            ارسال رزومه
          </div>
        </div>
      </div>
    </>
  );
};
